// ABOUTME: Small filled triangle caret for select/dropdown indicators
// ABOUTME: 8x5 triangle pointing down, used in unit selector dropdowns

interface CaretDownSmallIconProps {
  className?: string
  color?: string
}

export const CaretDownSmallIcon = ({ className = "", color = "#9CA3AF" }: CaretDownSmallIconProps) => (
  <svg
    className={className}
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0l4 5 4-5z"
      fill={color}
    />
  </svg>
)
